<template>
  <div>
    <homeHead></homeHead>
    <homeNav></homeNav>
    <breadcrumb :positionData="positionData"></breadcrumb>
    <div class="dynamics-box clearfix">
      <projectMenu :positionData="positionData"></projectMenu>
      <rightContent></rightContent>
    </div>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
import homeHead from "@/components/Public/head.vue";
import homeNav from "@/components/Public/nav.vue";
import breadcrumb from "@/components/Public/breadcrumb.vue";
import projectMenu from "@/components/Public/projectMenu.vue";
import rightContent from "./rightContent.vue";
import homeFooter from "@/components/Public/footer.vue";
export default {
  components: {
    homeHead,
    homeNav,
    breadcrumb,
    projectMenu,
    rightContent,
    homeFooter
  },
  metaInfo() {
    return {
      title: this.$store.state.webInfo.title + "-" + this.title,
      meta: [
        {
          name: this.$store.state.webInfo.key_words,
          content: this.$store.state.webInfo.describe
        }
      ],
      link: [
        {
          rel: "asstes",
          href: this.$url.webUrl
        }
      ]
    };
  },
  data() {
    return {
      title: "",
      id: null, //一级导航
      second_navId: null, //二级导航
      positionData: [] //当前位置
    };
  },
  created() {
    this.id = Number(this.$route.query.id);
    this.second_navId = Number(this.$route.query.second_navId);
    if (this.id) {
      // let id = this.second_navId?this.second_navId:this.id
      this.$db.get(this.$url.channel.childList + "?id=" + this.id).then(res => {
        this.positionData = res.data;
        this.positionData.forEach(element => {
          if (element.pid == 0) {
            this.title = element.title;
          }
        });
      }).catch(err => {
            console.log(err);
          });
    }
  },
  methods: {
    getPositionData() {
      this.$db.get(this.$url.channel.childList + "?id=" + this.id).then(res => {
        this.positionData = res.data;
        this.positionData.forEach(element => {
          if (element.pid == 0) {
            this.title = element.title;
          }
        });
      }).catch(err => {
            console.log(err);
          });
    }
  },
  watch: {
    "$route.query.id": function(value) {
      this.id = value;
      this.getPositionData();
    },
    "$route.query.second_navId": function(value) {
      if (value) {
        this.second_navId = value;
        this.getPositionData();
      } else if (typeof value == "undefined") {
        this.getPositionData();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.dynamics-box {
  // display: flex;
  // justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamics/index.vue